import { Footer, Header } from '@lectura/ui';
import Link from 'next/link';
import type { ReactNode } from 'react';
import { requiredPublic } from '@/lib/required-env';
import { UserMenu } from './UserMenu';

const BRAND = requiredPublic(process.env.NEXT_PUBLIC_BRAND_NAME, 'NEXT_PUBLIC_BRAND_NAME');

export function SiteShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-[var(--color-surface-muted)]">
      <Header
        brandName={BRAND}
        nav={
          <>
            <Link href="/" className="hover:text-brand-700">
              Kezdőlap
            </Link>
            <Link href="/library" className="hover:text-brand-700">
              Könyvtár
            </Link>
            <Link href="/collections" className="hover:text-brand-700">
              Kollekciók
            </Link>
            <Link href="/shelf" className="hover:text-brand-700">
              Polcom
            </Link>
            <Link href="/about" className="hover:text-brand-700">
              Rólunk
            </Link>
          </>
        }
        actions={<UserMenu />}
      />
      <main className="flex-1">{children}</main>
      <Footer
        brandName={BRAND}
        description="Felhő-natív ePUB platform — bármilyen formátum, egy egységes olvasó UI alatt."
        columns={[
          {
            title: 'Termék',
            links: [
              { label: 'Funkciók', href: '/features' },
              { label: 'Árazás', href: '/pricing' },
              { label: 'Integráció', href: '/integrations' },
              { label: 'API', href: '/docs/api' },
            ],
          },
          {
            title: 'Megoldások',
            links: [
              { label: 'Kiadóknak', href: '/solutions/publishers' },
              { label: 'Iskoláknak', href: '/solutions/schools' },
              { label: 'Vállalatoknak', href: '/solutions/enterprise' },
              { label: 'Könyvtáraknak', href: '/solutions/libraries' },
            ],
          },
          {
            title: 'Cég',
            links: [
              { label: 'Rólunk', href: '/about' },
              { label: 'Karrier', href: '/careers' },
              { label: 'Adatvédelem', href: '/privacy' },
              { label: 'ÁSZF', href: '/terms' },
            ],
          },
        ]}
      />
    </div>
  );
}
